import { de, enUS, fr, it } from 'date-fns/locale';

export const Locales = {
  de,
  en: enUS,
  fr,
  it,
};
